



















import { State, Mutation } from 'vuex-class';
import { Component } from 'vue-property-decorator';
import ApartmentDto from '@/app/apartments/dto/apartment.dto';
import HandlesErrorMixin from '@/app/core/mixins/handles-error.mixin';
import ConfirmationDialog from '@/app/core/components/confirmation-dialog.vue';
import ReservationsModule from '../store';
import ReservationDto from '../dto/reservation.dto';
import ListReservationsDto from '../dto/list-reservations.dto';
import ReservationsDataTable from '../components/reservations-data-table.vue';
import reservationsService, { cancelReservation } from '../services/reservations.service';

@Component({
  metaInfo(this: Reservations) {
    return { title: this.$t('pageTitle.reservations').toString() };
  },
  components: {
    ReservationsDataTable,
  },
})
export default class Reservations extends HandlesErrorMixin {
  private loading = true;
  private reservations: ReservationDto[] = [];
  private totalReservations = 0;

  @State((state) => state.reservations.filters)
  private filters!: ListReservationsDto;

  @Mutation
  private setFilters!: typeof ReservationsModule.prototype.setFilters;

  onSearch(q: string) {
    this.setFilters({
      ...this.filters,
      q,
    });

    this.loadReservations();
  }

  onFilterByApartment(apartmentId: string) {
    this.setFilters({
      ...this.filters,
      apartmentId,
    });

    this.loadReservations();
  }

  onFromDateChange(from: string) {
    this.setFilters({
      ...this.filters,
      from,
    });

    this.loadReservations();
  }

  onToDateChange(to: string) {
    this.setFilters({
      ...this.filters,
      to,
    });

    this.loadReservations();
  }

  async onCancel(reservation: ReservationDto) {
    const apartment = (reservation.apartment as ApartmentDto).name;
    const title = this.$t('title.cancelReservation');
    const message = this.$t('message.confirmCancelReservation', { apartment });
    const confirm = await this.$dialog.open(ConfirmationDialog, { title, message });

    if (confirm) {
      this.loading = true;
      try {
        await cancelReservation(reservation.id as string);
        this.loadReservations();
        this.$notify.success(this.$t('success.reservationCancelled').toString());
      } catch (err) {
        this.handleError(err);
      } finally {
        this.loading = false;
      }
    }
  }

  async onDelete(reservation: ReservationDto) {
    const apartment = (reservation?.apartment as ApartmentDto).name;
    const title = this.$t('title.deleteReservation');
    const message = this.$t('message.confirmDeleteReservation', { apartment });
    const confirm = await this.$dialog.open(ConfirmationDialog, { title, message });

    if (confirm) {
      try {
        await reservationsService.deleteReservation(reservation.id as string);
        this.loadReservations();
      } catch (err) {
        this.handleError(err);
      }
    }
  }

  onPageChange(page: number) {
    this.setFilters({
      ...this.filters,
      page,
    });

    this.loadReservations();
  }

  onUpdateItemsPerPage(itemsPerPage: number) {
    this.setFilters({
      ...this.filters,
      page: 1,
      itemsPerPage,
    });

    this.loadReservations();
  }

  async loadReservations() {
    this.loading = true;

    try {
      const response = await reservationsService.listReservations(this.filters);

      this.reservations = response.data.items;
      this.totalReservations = response.data.totalItems;
    } catch (error) {
      this.handleError(error);
    } finally {
      this.loading = false;
    }
  }

  mounted() {
    this.loadReservations();
  }
}
